<template>
    <div class="container">
        <el-bread-cumb :bread-cumb="breadCumb"></el-bread-cumb>
        <div class="warp50">
            <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px">
                <el-form-item label="用户名" prop="username">
                    <el-input type="text" v-model="userForm.username" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="real_name">
                    <el-input type="text" v-model="userForm.real_name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input type="text" v-model="userForm.mobile" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input type="text" v-model="userForm.email" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label=" ">
                    <el-button type="primary" :loading="loading" @click="submitForm('userForm')">编辑</el-button>
                    <el-button @click="resetForm('userForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import ElBreadCumb from '../../../components/BreadCumb.vue'

    export default {
        components: { ElBreadCumb },
        data() {
            var checkName = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入用户名'));
                }
                callback();
            };
            var checkRealName = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入姓名'));
                }
                callback();
            };
            var checkMobile = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入手机号'));
                }
                if (!this.$valid.mobile(value)) {
                    callback(new Error('请输入正确格式的手机号'));
                }
                callback();
            };
            var checkEmail = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入邮箱'));
                }
                if (!this.$valid.email(value)) {
                    callback(new Error('请输入正确格式的邮箱'));
                }
                callback();
            };
            return {
                loading: false,
                userForm: {
                    user_id: '',
                    username: '',
                    real_name: '',
                    mobile: '',
                    email: '',
                    owner: ''
                },
                rules: {
                    username: [
                        { validator: checkName, trigger: 'blur'}
                    ],
                    real_name: [
                        { validator: checkRealName, trigger: 'blur'}
                    ],
                    mobile: [
                        { validator: checkMobile, trigger: 'blur'}
                    ],
                    email: [
                        { validator: checkEmail, trigger: 'blur'}
                    ]
                }
            };
        },
        created (){
            this.userForm.user_id = this.$route.params.id;

            //获取用户信息
            let params = {user_id: this.userForm.user_id};
            this.$api.get(this.$apiUrl.editUser,params,(res)=>{
                this.userForm.username = res.data.username;
                this.userForm.real_name = res.data.real_name;
                this.userForm.mobile = res.data.mobile;
                this.userForm.email = res.data.email;
                this.userForm.owner = this.$store.getters.username;
            })
        },
        computed: {
            breadCumb: function(){
                return [{'name':'管理员管理','path':`/user/list/${this.$route.params.ruleId}`},{'name':'编辑','path':''}]
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.$api.post(this.$apiUrl.editUser,{...this.userForm},(res)=>{
                            this.loading = false;
                            this.$message.success('编辑成功');
                            this.$router.push({path:`/user/list/${this.$route.params.ruleId}`})
                        },(res)=>{
                            this.loading = false;
                            this.$message(res.msg);
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// edit.vue?9f422766